<template>
  <div>
    <table-manager @filterChanged="filterChanged" @paginationChanged="paginationChanged" :options="options" @ClickOnAddButton="showAdd"/>

    <basic-table
      v-if="ISGattributes"
      :items="ISGattributes"
      :fields="ISGattributesFields"
      @ClickOnDeleteButton="ClickOnDeleteButton"
      @ClickOnEditButton="editItem"
      :filter="filter"
      :perPage="perPage"
      :currentPage="currentPage"
      v-model="totalRows"
      isDelete="true"
      isEdit="true"/>
    <table-manager-bottom
      :totalRows="totalRows" :perPage="perPage"
      v-model="currentPage"/>
      <editModal :editItem="selectedISGattributes"/>
  </div>
</template>

<script>
import editModal from './editModal'

export default {
  components: {
    editModal
  },
  data () {
    return {
      ISGattributesFields: [
        {key: 'id', label: 'ID', sortable: true},
        {key: 'attr_name', label: this.$i18n.t('Full name'), sortable: true},
        {key: 'attr_id', label: this.$i18n.t('Attribute id'), sortable: true},
        {key: 'vendor_id', label: this.$i18n.t('Vendor id'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      selectedISGattributes: null,
      options: {
        isShowAddButton: true
      },
      filter: null,
      perPage: 20,
      totalRows: 0,
      currentPage: 1
    }
  },
  methods: {
    showAdd () {
      this.selectedISGattributes = {
        id: 0,
        attr_id: '',
        vendor_id: '',
        attr_name: ''
      }
      this.$root.$emit('bv::show::modal', 'modalEditISGattributesSettings', '#btnShow')
    },
    editItem (item) {
      this.selectedISGattributes = JSON.parse(JSON.stringify(item))
      this.$root.$emit('bv::show::modal', 'modalEditISGattributesSettings', '#btnShow')
    },
    ClickOnDeleteButton (item) {
      this.$root.$emit('showConfirmation', 'Confirmation', this.$i18n.t('Are you sure you want to delete one of "ISG attributes"?'), this.deleteItem, item)
    },
    deleteItem (item) {
      let response = this.$store.dispatch('Settings/DELETE_ISG_ATTRIBUTES', item.id)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Settings/GET_ISG_ATTRIBUTES')
          this.$root.$emit('makeToasts')
        }
      })
    },
    filterChanged (value) {
      this.filter = value
    },
    paginationChanged (value) {
      this.perPage = value
    }
  },
  computed: {
    ISGattributes () {
      return this.$store.getters['Settings/ISG_ATTRIBUTES']
    }
  },
  mounted () {
    this.$store.dispatch('Settings/GET_ISG_ATTRIBUTES')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/network/ISGattributes/main.vue